import { viewStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsView";
import { colorStrings, fontFamilyAlt } from "@waytek/Utilities/variables";
import { css } from "styled-components";

viewStyles.noPaymentsWrapper = {
    ...viewStyles.noPaymentsWrapper,

    css: css`
        ${viewStyles.noPaymentsWrapper?.css}

        height: auto;
        min-height: 400px;
    `,
};

viewStyles.noPaymentsIcon = {
    ...viewStyles.noPaymentsIcon,

    color: colorStrings.commonGlobalGuardianBlue,
};

viewStyles.noPaymentsText = {
    ...viewStyles.noPaymentsText,

    fontFamily: fontFamilyAlt,
    transform: "none",
};
